import React from 'react';
import css from './multi-actions.module.scss';
import Typography from '../Typography/Typography';
import Collapse from '@mui/material/Collapse';
import { Stack } from '../Stack/Stack';
import { Button, ButtonGroup } from '../Button/Button';
import { useTranslation } from 'utils/translation';
import { refetchActiveQueriesDelayed } from '../../../utils/QueryClientProvider';

const MultiActions = ({ actions, items, isOpen }: any) => {
  const { t } = useTranslation();

  return (
    <div className={css.root}>
      <Collapse in={isOpen}>
        <div className={css.content}>
          <Stack direction="row" align="center">
            <div style={{ flex: 1 }}>
              <Typography variant="text-secondary">
                {t('{{ count }} selected', { count: items.length })}
              </Typography>
            </div>
            <div style={{ flex: 4 }}>
              <ButtonGroup align="center">
                {actions.map((item: any, index: any) => (
                  <Button
                    startIcon={item.icon}
                    variant="text"
                    size="small"
                    key={index}
                    onClick={async () => {
                      await item.action(items);
                      await refetchActiveQueriesDelayed();
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
            <div style={{ flex: 1 }}></div>
          </Stack>
        </div>
      </Collapse>
    </div>
  );
};

export default MultiActions;
